export default __webpack_public_path__ + "static/media/video.ed11d389.svg";